<template>
  <div class="forum-post">
    <div class="forum-post__header">
      <div class="mb-2 ml-2 sm:flex-1 sm:flex sm:justify-center">
        <span class="w-full">{{ post.title }}</span>
        <span
          v-if="post.episode < currentEpisode"
          class="ml-2"
        >[archived]</span>
      </div>
      <div class="flex sm:flex-1 sm:justify-around">
        <div class="has-border">
          <span class="mr-1">USER</span>
          <span class="font-bold">{{ post.user }}</span>
        </div>
        <div class="has-border">
          <span class="mr-1">DAY</span>
          <span class="font-bold">{{ post.day }}</span>
        </div>
      </div>
    </div>
    <div class="forum-post__content">
      <span v-html="post.message" />
    </div>
    <div
      class="forum-post__footer"
      @click="open = !open"
    >
      COMMENTS {{ post.comments.length }}
    </div>
    <transition name="fade">
      <div v-if="open">
        <NewsForumContentPostComment
          v-for="comment in post.comments"
          :key="`${post.id}-${comment.id}`"
          :comment="comment"
        />
        <div
          class="forum-post__comment"
          @click="showPermissionPending"
        >
          Comment
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NewsForumContentPostComment from '@/components/News/NewsForumContentPostComment.vue'

export default {
  name: 'NewsForumContentPost',

  components: {
    NewsForumContentPostComment,
  },

  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      open: false,
    }
  },

  computed: {
    ...mapGetters({
      currentEpisode: 'auth/currentEpisode',
    }),
  },

  methods: {
    ...mapActions({
      showPermissionPending: 'auth/showPermissionPending',
    }),
  },
}
</script>

<style lang="postcss" scoped>
.has-border {
  @apply ml-2 pl-2 border-l-4 border-blue-darkest;
}
.forum-post {
  @apply mt-4;

  &__header {
    font-family: 'univia-pro';
    font-size: 12px;

    @apply bg-blue flex flex-col items-start pl-2 text-blue-darkest uppercase py-2;
  }

  &__content {
    font-family: 'proxima-nova';
    font-size: 20px;
    font-weight: 500;
    @apply flex items-center bg-blue-light p-8 text-blue-darkest;
  }

  &__footer {
    height: 41px;
    font-family: 'proxima-nova';
    font-size: 16px;
    @apply flex items-center bg-blue-dark border border-blue p-2 text-blue-light cursor-pointer select-none;
  }

  &__comment {
    height: 41px;
    font-family: 'proxima-nova';
    font-size: 16px;
    @apply flex items-center justify-end bg-blue-dark border border-blue p-2 text-blue-light cursor-pointer;
  }
}

@screen sm {
  .forum-post {
    &__header {
      @apply flex-row justify-around;
    }
  }
}

@screen lg {
  .forum-post {
    &__header {
      font-size: 14px;
    }
  }
}

@screen xl {
  .forum-post {
    &__header {
      font-size: 24px;
    }
  }
}
</style>
